<div>
  <app-nav-bar></app-nav-bar>
</div>
<p-toast position="top-right"></p-toast>
